// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__3ofx_","checkbox":"Checkbox_checkbox__3KXxB","pro":"Checkbox_pro__1Kv70","disabled":"Checkbox_disabled__2Xb6c","label":"Checkbox_label__29sqM"};